import styled from "@emotion/styled";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { useMediaQuery, translate } from "@kaltura/mediaspace-shared-utils";
import { Button, Modal, ModalTitle, ModalContent, ModalActions } from "@kaltura/ds-react-components";
import VerticalFilterBar, { VerticalFilterBarProps } from "../vertical-filter-bar/VerticalFilterBar";
import { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";

export interface FilterBarProps extends VerticalFilterBarProps {
    isModalOpen?: boolean;
    onModalClose?: () => void;
    inModal?: boolean;
}

const StyledModalContent = styled(ModalContent)({
    minWidth: 391,
});

const baseClassName = "kms-ds-filters-modal";

/**
 * global search filter bar
 */
export function FilterBar(props: FilterBarProps) {
    const { isModalOpen = false, onModalClose, inModal, ...filterbarProps } = props;

    const theme = useTheme();
    const mdScreen = useMediaQuery(theme.breakpoints.up("md"));

    // check from context if this is kaf
    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    return (
        <>
            {mdScreen && !inModal && !isKaf && <VerticalFilterBar {...filterbarProps} />}
            {(!mdScreen || isKaf || inModal) && (
                <Modal
                    open={isModalOpen}
                    onClose={onModalClose}
                    classes={{ paper: baseClassName }}
                    className={`${baseClassName}-outer`}
                >
                    <ModalTitle className={`${baseClassName}-title`}>{translate("Filters")}</ModalTitle>
                    <StyledModalContent className={`${baseClassName}-content`}>
                        <VerticalFilterBar {...filterbarProps} />
                    </StyledModalContent>
                    <ModalActions className={`${baseClassName}-actions`}>
                        <Button
                            variant="borderless"
                            color={"secondary"}
                            onClick={onModalClose}
                            className={`${baseClassName}-actions-close-button`}
                        >
                            {translate("Close")}
                        </Button>
                    </ModalActions>
                </Modal>
            )}
        </>
    );
}
export default FilterBar;
